module.exports = __webpack_public_path__ + "static_pc/img/31.45f6c7f3.jpg";